export const HtmlNodeId = {
  PDF_RESULT_TITLES_AND_LOGO: '____pdf_result_titles_and_logo',
  PDF_RESULT_PRODUCTS: '____pdf_result_products',
  PDF_RESULT_TOTAL_PRICE: '____pdf_result_total_price',
  PDF_RESULT_CONTACTS: '____pdf_result_contacts',
  PRODUCTS_CAROUSEL: '____products_carousel',
  PREVIEW_CONTAINER: '___preview_container',
};
